import React, { useContext, useState, useEffect } from 'react';
import { FAQPageJsonLd } from 'next-seo';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

import { AnnouncementContext } from 'components/AnnouncementBar/AnnouncementBarProvider';
import websitePage from 'hoc/websitePage/websitePage';
import OldPageSectionHeading from 'components/structure/OldPageSectionHeading';
import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import CollapsePanel from 'components/ui/CollapsePanel/CollapsePanel';
import SafeAnchorOffset from 'components/SafeAnchorOffset/SafeAnchorOffset';
import sanitizer from 'utils/sanitizer';

import { List, ListItem } from './styles/List';
import BlockHeading from './patterns/BlockHeading/BlockHeading';

function Faq() {
  const { formatMessage } = useContext(NuDsContext);
  const { setVisibleWhenAllowed } = useContext(AnnouncementContext);
  const [interactionCounter, setInteractionCounter] = useState(0);

  useEffect(() => {
    if (interactionCounter > 2) {
      setVisibleWhenAllowed(true);
    }
  }, [interactionCounter]);

  const faqSections = formatMessage({ id: 'cms.faqPage.faqSection' });
  const faqStructuredObject = faqSections.map(faqSection => (
    faqSection.faqCategory.faqQuestions.map(faqQuestion => (
      {
        questionName: sanitizer.forJSON(faqQuestion.title),
        acceptedAnswerText: sanitizer.forJSON(faqQuestion.content),
      }
    )))).flat();

  return (
    <>
      <OldPageSectionHeading intlKey="cms.faqPage.pageTitle" />
      <Section backgroundColor="white.dark">
        {faqSections.map(faqSection => (
          <Block key={faqSection.faqCategory.slug} justifyContent="center" blockWidth="100%">
            <SafeAnchorOffset id={faqSection.faqCategory.slug} />
            <BlockHeading href={`/perguntas#${faqSection.faqCategory.slug}`}>
              {faqSection.faqCategoryTitle}
            </BlockHeading>
            <List>
              {faqSection.faqCategory.faqQuestions.map(faqQuestion => (
                <ListItem key={`question-${faqQuestion.slug}`}>
                  <CollapsePanel
                    title={faqQuestion.title}
                    body={faqQuestion.content}
                    id={faqQuestion.slug}
                    handleClick={() => { setInteractionCounter(interactionCounter + 1); }}
                  />
                </ListItem>
              ))}
            </List>
          </Block>
        ))}
      </Section>
      <FAQPageJsonLd mainEntity={faqStructuredObject} />
    </>
  );
}

export default websitePage({
  routeKey: 'FAQ',
})(Faq);
